<script lang="ts">
  export let word: string
</script>

<h2>{word}</h2>

<p>
  Sur cette échelle à 7 niveaux, évaluez la facilité avec laquelle vous pouvez vous créer une image mentale de ce verbe. (1 = très difficile de se faire une image mentale – 7 = très facile de se créer une image mentale)
</p>